export default {
	security: {
		securityBind: "सुरक्षा बाइंड",
		securitySettings: "सुरक्षा सेटिंग्स",
		level: "मध्यम",
		confirm: "पुष्टि करें",
		submitting: "सबमिट किया जा रहा है...",
		add: "जोड़ें",
		change: "बदलें",
		success: "सफलतापूर्वक अपडेट किया गया",
		select: "चुनें",

		birthday: "संपर्क जन्मदिन",
		birthdayDesc: "आसान संचार के लिए संपर्क जन्मदिन बाइंड करें। आपकी व्यक्तिगत जानकारी सुरक्षित रहेगी।",
		month: "महीना",
		day: "दिन",
		year: "वर्ष",
		birthdayRequired: "जन्मदिन आवश्यक है।",
		invalidBirthday: "अमान्य जन्मदिन।",
		invalidMonth: "अमान्य महीना।",
		invalidDay: "अमान्य दिन।",
		invalidYear: "अमान्य वर्ष।",
		updateBirthdayFail: "जन्मदिन अपडेट करने में विफल",
		birthdayVerify: "जन्मदिन बाइंड सत्यापन",
		birthdayVerifyDesc: "अपने अकाउंट की सुरक्षा बेहतर करने के लिए अपना जन्मदिन बाइंड करें।",

		email: "संपर्क ईमेल",
		emailDesc: "अकाउंट सुरक्षा के लिए ईमेल। केवल आप ही इसे बाइंड कर सकते हैं।",
		emailRequired: "ईमेल आवश्यक है।",
		emailInvalid: "गलत ईमेल पता।",
		updateEmailFail: "ईमेल अपडेट करने में विफल",
		emailVerify: "ईमेल बाइंड सत्यापन",
		emailVerifyDesc: "अपने अकाउंट की सुरक्षा बेहतर करने के लिए अपने ईमेल पते को सत्यापित करें।",

		phone: "फ़ोन नंबर",
		bindPhone: "फ़ोन नंबर बाइंड करें",
		phoneDesc: "अकाउंट सुरक्षा के लिए फ़ोन नंबर। केवल आप ही इसे बाइंड कर सकते हैं।",
		phoneRequired: "फ़ोन नंबर आवश्यक है।",
		phoneUsed: "कृपया कोई अलग फ़ोन नंबर उपयोग करें।",
		updatePhoneFail: "फ़ोन नंबर अपडेट करने में विफल",
		noCode: "कोड प्राप्त नहीं हुआ?",
		smsHelp: "यदि आपने कई बार कोशिश की है लेकिन फिर भी सत्यापन कोड प्राप्त नहीं हुआ है।",
		smsTips1: "1. जाँचें कि आपने जो मोबाइल नंबर दर्ज किया है वह सही है।",
		smsTips2: "2. जाँचें कि आपका मोबाइल नंबर पुराना तो नहीं है।",
		smsTips3: "3. जाँचें कि संदेश SMS bin में तो नहीं है।",
		smsTips4: "4. संदेश कुछ मिनट देरी से आ सकता है।",
		phoneVerify: "फ़ोन नंबर बाइंड सत्यापन",
		phoneVerifyDesc: "अपने अकाउंट की सुरक्षा बेहतर करने के लिए अपना फ़ोन नंबर सत्यापित करें।",

		setPassword: "पासवर्ड सेट करें",
		passwordDesc: "अपना साइन इन पासवर्ड सेट करें।",
		clickSelectBirthday: "जन्मदिन चुनने के लिए क्लिक करें",
		selectBirthday: "जन्मदिन चुनें",
		confirm: "पुष्टि करें",
		cancel: "रद्द करें",
		withdrawPassword: "निकासी पासवर्ड",
		withdrawpasswordDesc: "अपना निकासी (Withdraw) पासवर्ड सेट करें।",
		set: "सेट करें",
	},
	contactPhone: {
		title: "फ़ोन नंबर बदलें",
		titleMobile: "बदलें",
		description: "आसान संचार के लिए संपर्क फ़ोन नंबर जोड़ें। आपकी व्यक्तिगत जानकारी सुरक्षित रहेगी।",
		label: "संपर्क फ़ोन नंबर",
		confirm: "पुष्टि करें",
		submitting: "सबमिट हो रहा है...",
		required: "फ़ोन नंबर आवश्यक है",
		invalid: "अमान्य फ़ोन नंबर",
		success: "फ़ोन नंबर सफलतापूर्वक अपडेट हो गया!",
		updateFailed: "अपडेट विफल",
		tryAgain: "अपडेट विफल, कृपया बाद में पुनः प्रयास करें",
		verifyTitleMobile: "फ़ोन सत्यापन",
		titleMobile: "फ़ोन लिंक करें",
		changeTitleMobile: "फ़ोन बदलें",
		securityTip: "खाता सुरक्षा के लिए फ़ोन। केवल आप ही इसे लिंक कर सकते हैं।",
		placeholder: "फ़ोन नंबर",
		noCodeReceived: "कोड प्राप्त नहीं हुआ?",
		codeDescription: "नीچے دیے گئے اپنے संपर्क विवरण पर भेजा गया 6-अंकीय सत्यापन कोड दर्ज करें:",
		resendIn: "{countdown} सेकंड में पुन: भेजें",
		resend: "पुन: भेजें",
		submitting: "जमा किया जा रहा है...",
		confirm: "पुष्टि करें",
		invalidCode: "कृपया एक मान्य 6-अंकीय कोड दर्ज करें",
		required: "फ़ोन नंबर आवश्यक है",
		invalid: "कृपया एक मान्य फ़ोन नंबर दर्ज करें",
		success: "सफलतापूर्वक अपडेट किया गया",
		updateFailed: "अपडेट विफल रहा",
		tryAgain: "कृपया बाद में पुन: प्रयास करें"
	},

	contactEmail: {
		title: "ईमेल बदलें",
		titleMobile: "बदलें",
		description: "आसान संचार के लिए संपर्क ईमेल जोड़ें। आपकी व्यक्तिगत जानकारी सुरक्षित रहेगी।",
		label: "संपर्क ईमेल",
		placeholder: "ईमेल",
		confirm: "पुष्टि करें",
		submitting: "सबमिट हो रहा है...",
		required: "ईमेल खाली नहीं हो सकता",
		invalid: "कृपया सही ईमेल पता दर्ज करें",
		success: "ईमेल सफलतापूर्वक अपडेट हो गया!",
		updateFailed: "अपडेट विफल",
		tryAgain: "अपडेट विफल, कृपया बाद में पुनः प्रयास करें",
		verifyTitleMobile: "ईमेल सत्यापन",
		titleMobile: "ईमेल लिंक करें",
		changeTitleMobile: "ईमेल बदलें",
		securityTip: "खाता सुरक्षा के लिए ईमेल। केवल आप ही इसे लिंक कर सकते हैं।",
		noCodeReceived: "कोड प्राप्त नहीं हुआ?",
		codeDescription: "नीचे दिए गए अपने संपर्क विवरण पर भेजा गया 6-अंकीय सत्यापन कोड दर्ज करें:",
		resendIn: "{countdown} सेकंड में पुन: भेजें",
		resend: "पुन: भेजें",
		submitting: "जमा किया जा रहा है...",
		confirm: "पुष्टि करें",
		invalidCode: "कृपया एक मान्य 6-अंकीय कोड दर्ज करें",
		required: "ईमेल आवश्यक है",
		invalid: "कृपया एक मान्य ईमेल पता दर्ज करें",
		success: "सफलतापूर्वक अपडेट किया गया",
		updateFailed: "अपडेट विफल रहा",
		tryAgain: "कृपया बाद में पुन: प्रयास करें"
	},

	accountInfo: {
		profileInfo: "प्रोफ़ाइल जानकारी",
		contactInfo: "संपर्क जानकारी",
		privacy: "गोपनीयता",
		contactEmail: "संपर्क ईमेल",
		contactPhone: "संपर्क फ़ोन नंबर",
		addEmailDesc: "आसान संचार के लिए संपर्क ईमेल जोड़ें। आपकी व्यक्तिगत जानकारी सुरक्षित रहेगी।",
		addPhoneDesc: "आसान संचार के लिए संपर्क फ़ोन नंबर जोड़ें। आपकी व्यक्तिगत जानकारी सुरक्षित रहेगी।",
		hideUsername: "सार्वजनिक सूचियों से मेरा उपयोगकर्ता नाम छिपाएं",
		add: "जोड़ें",
		change: "बदलें",
		idLabel: "ID: ",
		vip: "VIP ",
		player: "खिलाड़ी",
		copied: "कॉपी हो गया!",
		hideSuccess: "उपयोगकर्ता नाम सफलतापूर्वक छिपाया गया",
		showSuccess: "उपयोगकर्ता नाम सफलतापूर्वक दिखाया गया",
		operationFailed: "ऑपरेशन विफल",
		editProfile: "प्रोफ़ाइल संपादित करें",
		contactInfo: "संपर्क जानकारी",
		contactEmail: "संपर्क ईमेल",
		emailTip: "आसान संचार के लिए एक संपर्क ईमेल जोड़ें। आपकी व्यक्तिगत जानकारी सुरक्षित रहेगी।",
		change: "बदलें",
		addEmail: "ईमेल जोड़ें",
		contactPhone: "संपर्क फ़ोन नंबर",
		phoneTip: "सुरक्षित खाता सत्यापन के लिए अपना फ़ोन नंबर जोड़ें।",
		addPhone: "फ़ोन नंबर जोड़ें",
		birthdayBind: "जन्मदिन बाइंड सत्यापन",
		birthdayTip: "अपने खाते की सुरक्षा में सुधार के लिए अपना जन्मदिन बाइंड करें।",
		addBirthday: "जन्मदिन जोड़ें",
		personalInfo: "व्यक्तिगत जानकारी",
		personalTip: "अधिक सेवाओं को अनलॉक करने के लिए अपनी पहचान सत्यापित करें। आपका डेटा सुरक्षित है।",
		verifyNow: "अभी सत्यापित करें",
		hideUsernameTip: "सक्षम होने पर, अन्य उपयोगकर्ता सार्वजनिक सूचियों में आपका उपयोगकर्ता नाम नहीं देख पाएंगे।",
	},

	kyc: {
		title: "पहचान सत्यापन",
		verifyIdentity: "अपनी पहचान सत्यापित करें",
		completeDesc: "अपने अकाउंट को सुरक्षित रखने और सभी सुविधाएं अनलॉक करने के लिए पहचान सत्यापन पूरा करें।",
		failed: "सत्यापन विफल। कृपया पुनः प्रयास करें।",
		reVerify: "फिर से सत्यापित करें",
		checkYouOut: "आइए आपकी पहचान सत्यापित करें",
		prepareDoc: "अपना दस्तावेज़ तैयार करें",
		prepareDocDesc: "एक वैध पहचान दस्तावेज़ तैयार रखें।",
		useSmartphone: "स्मार्टफ़ोन का उपयोग करें",
		useSmartphoneDesc: "सत्यापन पूरा करने के लिए आपको एक स्मार्टफ़ोन की आवश्यकता होगी।",
		scanQr: "QR कोड स्कैन करें",
		scanQrDesc: "मोबाइल पर जारी रखने के लिए अपने फ़ोन से QR कोड स्कैन करें।",
		noSmartphone: "स्मार्टफ़ोन नहीं है?",
		completeOnMobile: "मोबाइल पर पूरा करें"
	},

	verify: {
		title: "सत्यापन",
		personalVerification: "व्यक्तिगत सत्यापन",
		weak: "कमज़ोर",
		level1: "स्तर 1",
		personalInfo: "व्यक्तिगत जानकारी",
		personalInfoDesc: "अपने अकाउंट की सुरक्षा बेहतर करने के लिए अपनी व्यक्तिगत जानकारी पूरी करें।",
		verifyNow: "अभी सत्यापित करें",
		level2: "स्तर 2",
		kycVerification: "KYC सत्यापन",
		kycDesc: "उच्च सीमाएं और पूर्ण एक्सेस अनलॉक करने के लिए KYC सत्यापन पूरा करें।",
		docTip: "जमा करने से पहले सुनिश्चित करें कि आपके दस्तावेज़ स्पष्ट और वैध हैं।"
	},

	personalInfo: {
		verify: "सत्यापन",
		completeInfo: "अपनी जानकारी पूरी करें",
		completeInfoDesc: "सत्यापन पूरा करने के लिए अपना व्यक्तिगत विवरण भरें।",
		firstName: "पहला नाम",
		paternalSurname: "पैतृक उपनाम",
		maternalSurname: "मातृक उपनाम",
		contactNumber: "संपर्क नंबर",
		phoneUsed: "यह फ़ोन नंबर पहले से उपयोग में है।",
		contactEmail: "संपर्क ईमेल",
		invalidEmail: "अमान्य ईमेल पता।",
		detailedAddress: "विस्तृत पता",
		city: "शहर",
		street: "गली",
		neighborhood: "मोहल्ला",
		houseNumber: "मकान नंबर",
		postalCode: "पिन कोड",
		save: "सहेजें",
		male: "पुरुष",
		female: "महिला"
	},

	withdrawPassword: {
		changeTitle: "निकासी पासवर्ड बदलें",
		setTitle: "निकासी पासवर्ड सेट करें",
		changeDesc: "अपना पुराना पासवर्ड दर्ज करें और नया निकासी पासवर्ड सेट करें।",
		setDesc: "अपने धन की सुरक्षा के लिए निकासी पासवर्ड सेट करें।",
		oldPlaceholder: "पुराना निकासी पासवर्ड",
		newPlaceholder: "नया निकासी पासवर्ड",
		confirmPlaceholder: "निकासी पासवर्ड की पुष्टि करें"
	},

	contactBirthday: {
		title: "संपर्क जन्मदिन",
		desc: "आसान संचार के लिए संपर्क जन्मदिन बाइंड करें। आपकी व्यक्तिगत जानकारी सुरक्षित रहेगी।",
		label: "संपर्क जन्मदिन",
		invalid: "अमान्य जन्मदिन।"
	},

	changePassword: {
		title: "पासवर्ड बदलें",
		expiredDesc: "आपका पासवर्ड समाप्त हो गया है। जारी रखने के लिए नया पासवर्ड सेट करें।",
		verifyOldDesc: "अपना पुराना पासवर्ड दर्ज करें और नया सेट करें।",
		passwordPlaceholder: "पुराना पासवर्ड",
		newPlaceholder: "नया पासवर्ड",
		confirmPlaceholder: "नए पासवर्ड की पुष्टि करें",
		lengthError: "पासवर्ड 6 से 30 अक्षरों का होना चाहिए।",
		sameAsOld: "नया पासवर्ड पुराने के समान नहीं हो सकता।",
		confirmRequired: "कृपया अपने नए पासवर्ड की पुष्टि करें।",
		notMatch: "पासवर्ड मेल नहीं खाते।",
		success: "पासवर्ड सफलतापूर्वक बदला गया",
		failed: "पासवर्ड बदलने में विफल"
	},

	settingsNav: {
		title: "सेटिंग्स",
		accountInfo: "खाता जानकारी",
		security: "सुरक्षा"
	},

	verificationBirthday: {
		title: "जन्मदिन",
		securityTip: "खाता सुरक्षा के लिए जन्मदिन। इसे केवल आप ही लिंक कर सकते हैं।",
		clickSelectBirthday: "जन्मदिन चुनने के लिए क्लिक करें",
		invalidBirthday: "अमान्य जन्मदिन",
		submitting: "जमा किया जा रहा है...",
		confirm: "पुष्टि करें",
		cancel: "रद्द करें",
		selectBirthday: "जन्मदिन चुनें",
		birthdayRequired: "जन्मदिन आवश्यक है",
		updateBirthdayFail: "जन्मदिन अपडेट करने में विफल",
		success: "सफलतापूर्वक अपडेट किया गया"
	}
};